import { z } from 'zod'

export const terminalConnectionTokenResponseSchema = z.object({
  secret: z.string(),
  publishableKey: z.string(),
  stripeAccountId: z.string().nullable(),
})

export const terminalPaymentResponseSchema = z.object({
  orderId: z.string(),
  paymentIntentId: z.string(),
  clientSecret: z.string(),
  publishableKey: z.string(),
  stripeAccountId: z.string().nullable(),
  amount: z.number(),
  currency: z.string(),
  mode: z.literal('payment'),
})
